import React, { useState } from 'react';
import { reduxForm, Field, Form, InjectedFormProps } from 'redux-form';
import { makeStyles } from '@material-ui/core';
import Fields from 'components/Fields';
import { Button } from 'components/Base';
import api from 'api';
import { Notify } from 'utils';
import Icons from 'components/Icons';

const useStyles = makeStyles({
  wrappedField: {
    margin: '8px 0'
  },
  error: {
    color: '#ed4337',
    display: 'flex',
    alignItems: 'center'
  },
  addons: {
    fontSize: '14px',
    fontWeight: 600
  }
});

const PasswordUpdateForm = ({ handleSubmit, reset }: InjectedFormProps) => {
  const classes = useStyles();
  const [isSubmitting, setisSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = (values: any) => {
    setisSubmitting(true);
    api
      .updateUserPassword(values)
      .then(() => {
        setError('');
        reset();
        Notify.success(`You have sucessfully updated your password`);
      })
      .catch(error => {
        setError(error.response.data.non_field_errors[0]);
      })
      .finally(() => {
        setisSubmitting(false);
      });
  };

  return (
    <Form
      style={{ marginTop: '-1rem', maxWidth: '500px' }}
      onSubmit={handleSubmit(submit)}
    >
      <Field
        className={classes.wrappedField}
        name="current_password"
        component={Fields.Text}
        label="Current password"
        autoComplete="off"
        type="password"
        required
      />
      <Field
        className={classes.wrappedField}
        name="new_password"
        component={Fields.Text}
        label="New password"
        autoComplete="off"
        type="password"
        required
      />
      <Field
        className={classes.wrappedField}
        name="confirm_password"
        component={Fields.Text}
        label="Confirm password"
        autoComplete="off"
        type="password"
        required
      />
      {error && (
        <div className={classes.error}>
          <Icons.ErrorIcon style={{ marginRight: '0.25rem' }} fill="#ed4337" />
          <div>{error}</div>
        </div>
      )}
      <Button
        isLoading={isSubmitting}
        type="submit"
        style={{ marginTop: '1rem' }}
      >
        Update password
      </Button>
    </Form>
  );
};

export default reduxForm({
  form: 'passwordUpdate',
  enableReinitialize: true
})(PasswordUpdateForm);
